import { render, staticRenderFns } from "./luqapay.vue?vue&type=template&id=2f5206f4"
import script from "./luqapay.vue?vue&type=script&lang=js"
export * from "./luqapay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports